// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sKKkow {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
  padding: 0 8px;
  font-family: var(--font-family-base, 'Source Sans 3, sans-serif');
}

.OxLIqm {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.424;
  color: var(--balance-text-color);
  margin: 0;
}

.WLPiEh {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.424;
  color: var(--balance-text-color);
  margin: 0;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Balance/Balance.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,iEAAiE;AACnE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2px;\n  padding: 0 8px;\n  font-family: var(--font-family-base, 'Source Sans 3, sans-serif');\n}\n\n.label {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.424;\n  color: var(--balance-text-color);\n  margin: 0;\n}\n\n.value {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.424;\n  color: var(--balance-text-color);\n  margin: 0;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `sKKkow`,
	"label": `OxLIqm`,
	"value": `WLPiEh`
};
module.exports = ___CSS_LOADER_EXPORT___;
